import { type WorkflowStateInfo } from './useWorkflowState';

/** Rótulo textual do estado: a cor sozinha não distingue Nacional de Local. */
export const StateLabel = ({ info }: { info: WorkflowStateInfo }) => (
  <span className="mpf-state-label" style={{ color: info.color }}>
    <span
      aria-hidden="true"
      className="mpf-state-label__dot"
      style={{ backgroundColor: info.color }}
    />
    Estado: {info.label}
  </span>
);

export default StateLabel;
